<app-new-custom-requisition-view
	*ngIf="vm$ | async as vm"
	[loading]="vm.loading"
	[isDisabled]="isDisabled"
	[selectedRequisitionId]="data?.selectedRequisitionId"
	(onSubmit)="onSubmit($event)"
	(onFormStatusChange)="onFormStatusChange($event)"
	(onSecondaryButtonClick)="closeModal()"
/>
